module.exports = __webpack_public_path__ + "assets/211f85cb40a7b856334e8e4980867334.png";